export default __webpack_public_path__ + "static/media/rev_f_pedals.55d4ed5c.webp";